<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="consumptionForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-12">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required placeholder="">
            <mat-option *ngFor="let type of trackingHelper.getConsumptionTypes()" [value]="type">
              {{ trackingHelper.getConsumptionTypeName(type) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-group row d-flex justify-content-center">
        <span>Type de relevé</span>
        <mat-radio-group
          class="ml-3"
          aria-label="Type de relevé"
          formControlName="measureType"
          (change)="measureTypeChanged($event)"
        >
          <mat-radio-button class="mr-1" value="MONTH">Mensuel</mat-radio-button>
          <mat-radio-button class="ml-1" value="PERIOD">Périodique</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="form-group column">
        <span *ngIf="f('measureType').value === 'PERIOD'">Début</span>
        <div class="row">
          <mat-form-field class="col-md-6">
            <mat-label>Mois</mat-label>
            <mat-select formControlName="monthStart" required placeholder="">
              <mat-option *ngFor="let month of trackingHelper.getMonthsNumbers()" [value]="month">
                {{ trackingHelper.getMonthName(month) }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Année</mat-label>
            <input matInput placeholder="" type="text" required formControlName="yearStart" />
            <mat-error>
              <span *ngIf="f('yearStart').hasError('required')">Veuillez saisir une année</span>
              <span *ngIf="f('yearStart').hasError('pattern')"
                >L'année soit être sur 4 chiffres</span
              >
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="currentMeasureType === 'PERIOD'">
          <span>Fin</span>
          <div class="row">
            <mat-form-field class="col-md-6">
              <mat-label>Mois</mat-label>
              <mat-select formControlName="monthEnd" required placeholder="">
                <mat-option *ngFor="let month of trackingHelper.getMonthsNumbers()" [value]="month">
                  {{ trackingHelper.getMonthName(month) }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-md-6">
              <mat-label>Année</mat-label>
              <input matInput placeholder="" type="text" required formControlName="yearEnd" />
              <mat-error>
                <span *ngIf="f('yearEnd').hasError('required')">Veuillez saisir une année</span>
                <span *ngIf="f('yearEnd').hasError('pattern')"
                  >L'année soit être sur 4 chiffres</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label
            >Valeur ({{ trackingHelper.getConsumptionTypeUnit(f('type').value) }})</mat-label
          >
          <mat-hint *ngIf="f('value').value == 0"
            >Une valeur de 0 réinitialisera les consommations pour la période</mat-hint
          >
          <input
            matInput
            type="text"
            placeholder=""
            required
            formControlName="value"
            decimalValue
          />
          <mat-error>
            <span *ngIf="f('value').hasError('required')">Veuillez saisir une valeur</span>
            <span *ngIf="f('value').hasError('pattern')"
              >La valeur doit être un nombre positif</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Prix (€)</mat-label>
          <input matInput type="text" placeholder="" formControlName="price" decimalValue />
          <mat-error>
            <span *ngIf="f('price').hasError('pattern')">Le prix doit être un nombre positif</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="dataAdded" class="text-center mb-1">
        <mat-icon class="align-middle" color="accent">check_circle</mat-icon
        ><span class="ml-2">Prêt pour le relevé suivant !</span>
      </div>
      <div class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          appTooltip="Valider"
          type="submit"
          [disabled]="formSubmitting"
        >
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          {{ dataAdded ? 'Terminer' : 'Annuler' }}
        </button>
      </div>
    </form>
  </div>
</div>
